<template>
  <div>
    <tree-view :data='json' :options='{rootObjectKey: "Tables"}'/>
  </div>
</template>
<style scoped>
</style>
<script>
import { getKeyFile } from '@/services'

export default {
  name: 'JsonView',
  props: {
    workspace: String,
    file: String,
    config: Object
  },
  data () {
    return {
      json: null
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    async reload () {
      const response = await getKeyFile(this.workspace, this.file, this.config['output'])
      this.json = response.data.content
    }
  },
  watch: {
    file: function () {
      this.reload()
    }
  }
}
</script>
